import { Select, MenuItem, Box, CircularProgress } from '@octanner/prism-core'
import React from 'react'
import { useGetCelebrationLevels } from '../hooks/useGetCelebrationLevels'

type Props = {
  onChange: (val: number) => void
  value: number | undefined
  programId: string
  error: boolean
  helperText?: string
  identityUuid?: string
}

const CelebrationLevelSelector: React.FC<Props> = ({
  programId,
  value,
  onChange,
  error,
  identityUuid,
}) => {
  const { data: celebrationLevels, loading } = useGetCelebrationLevels({
    programId,
    identityUuid,
  })
  return (
    <Box sx={{ display: 'flex', gap: 4, alignItems: 'center' }}>
      <Select
        value={value}
        onChange={(e) => {
          onChange(Number(e.target.value))
        }}
        sx={{ width: '400px' }}
        label="Anniversary year"
        error={error}
        helperText={error ? 'Required' : undefined}
        MenuProps={{
          style: {
            maxHeight: 400,
          },
        }}
      >
        {celebrationLevels?.map((level) => (
          <MenuItem key={level} value={level}>
            {`${level} ${level === 1 ? 'Year' : 'Years'}`}
          </MenuItem>
        ))}
      </Select>
      {loading && <CircularProgress size={25} />}
    </Box>
  )
}

export default CelebrationLevelSelector
